// lazy components
const Forgot = () => import("@components/popup/forgot/forgot.vue");
const ForgotLite = () => import("@components/popup/forgot/forgotLite.vue");
const ForgotTutor = () => import("@components/popup/forgot/forgotTutor.vue");
const Logout = () => import("@components/popup/common/logout.vue");
const Tutorial = () => import("@components/popup/common/tutorial.vue");
// student exam
const StuUnitExamCheck = () => import("@components/popup/student/units/examCheck/examCheck.vue");
const StuUnitExamLevelInfo = () => import("@components/popup/student/units/levelInfo/levelInfo.vue");
const StuTranscriptUnder40Alert = () => import("@components/popup/student/transcript/under40Alert/under40Alert.vue");
const StuTranscriptLevelUp = () => import("@components/popup/student/transcript/levelUp/levelUp.vue");
const StuTranscriptDetailAssign = () => import("@components/popup/student/transcript/detailAssign/detailAssign.vue");
const StuTranscriptDetailSelf = () => import("@components/popup/student/transcript/detailSelf/detailSelf.vue");
const StuTranscriptDetailQuestion = () => import("@components/popup/student/transcript/detailQuestion/detailQuestion.vue");
const StuExamSubmit = () => import("@components/popup/student/exam/submit/Submit.vue");
const StuExamComplete = () => import("@components/popup/student/exam/complete/Complete.vue");
const StuExamUnfinish = () => import("@components/popup/student/exam/unfinish/Unfinish.vue");
const StuExamDelete = () => import("@components/popup/student/exam/delete/Delete.vue");
const StuExamContinue = () => import("@components/popup/student/exam/continue/Continue.vue");
const StuWebConfirm = () => import("@components/popup/student/web/confirm/Confirm.vue");
const StuCinemaRoomComplete = () => import("@components/popup/student/cinema/complete/Complete.vue");
const StuCinemaRoomUnfinish = () => import("@components/popup/student/cinema/unfinish/Unfinish.vue");

// static components
import Error from "@components/popup/common/error.vue";
import Loading from "@components/popup/common/loading.vue";
import OldOsWarning from "@components/popup/common/oldOSWarning.vue";

const popupMap = {
    forgot: {
        'V2-PRO': Forgot,
        'V2-LITE': ForgotLite,
        'V2-TUTOR': ForgotTutor
    },
    logout: {
        'V2-PRO': Logout,
    },
    logoutNoCourse: {
        'V2-PRO': Logout,
    },
    error: {
        'V2-PRO': Error
    },
    loading: {
        'V2-PRO': Loading
    },
    stuUnitExamCheck: {
        'V2-PRO': StuUnitExamCheck
    },
    stuUnitExamLevelInfo: {
        'V2-PRO': StuUnitExamLevelInfo
    },
    stuTranscriptUnder40Alert: {
        'V2-PRO': StuTranscriptUnder40Alert
    },
    stuTranscriptLevelUp: {
        'V2-PRO': StuTranscriptLevelUp
    },
    stuTranscriptDetailAssign: {
        'V2-PRO': StuTranscriptDetailAssign
    },
    stuTranscriptDetailSelf: {
        'V2-PRO': StuTranscriptDetailSelf
    },
    stuTranscriptDetailQuestion: {
        'V2-PRO': StuTranscriptDetailQuestion
    },
    stuExamSubmit: {
        'V2-PRO': StuExamSubmit
    },
    stuExamComplete: {
        'V2-PRO': StuExamComplete
    },
    stuExamUnfinish: {
        'V2-PRO': StuExamUnfinish
    },
    stuExamDelete: {
        'V2-PRO': StuExamDelete
    },
    stuExamContinue: {
        'V2-PRO': StuExamContinue
    },
    stuWebConfirm: {
        'V2-PRO': StuWebConfirm
    },
    stuCinemaRoomComplete: {
        'V2-PRO': StuCinemaRoomComplete
    },
    stuCinemaRoomUnfinish: {
        'V2-PRO': StuCinemaRoomUnfinish
    },
    tutorial: {
        'V2-PRO': Tutorial,
    },
    oldOSWarning: {
        'V2-PRO': OldOsWarning,
    },
};

export const preloadPopupComponents = async (path) => {
    let promiseList = [];
    switch (path) {
        case 'student/index':
            promiseList = [Tutorial]
    }
    return await Promise.all(promiseList)
}

export const getPopupComponent = async (type, style) => {
    const typeMap = popupMap[type];
    if (!typeMap) {
        console.warn(`Popup type "${type}" not found in popupMap.`);
        return null;
    }

    let componentLoader = typeMap[style];
    if (!componentLoader) componentLoader = Object.values(typeMap)[0];

    if(!componentLoader) {
        console.warn(`component not found for type "${type}" and style "${style}"`);
        return
    }

    console.log('Loading component for type:', componentLoader);

    if(typeof componentLoader === 'function') {
        const component = await componentLoader();
        return component.default
    }
    else return componentLoader
};
